// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1_-iC","cls2":"PaperSelector-cls2_tyA PaperSelector-cls1_-iC","selected":"PaperSelector-selected_R7G"};